import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

import Layout from '@/layout/index.vue'
import sliderPath from './silderPath.js'
import NotFound from "@/views/404.vue"

export default new Router({
  routes: [{
      path: '/',
      component: Layout,
      children: sliderPath,
      redirect: 'ja'
    },
    // {
    //   path: '/login',
    //   name: '',
    //   component: resolve => require(['@/views/login/login.vue'], resolve)
    // },
    {
      path: '*',
      component: NotFound
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js